import {
    Tone,
    ToneIndex
} from "../model/core";
import {
    IntervalPattern,
    Scale,
    ScalePattern,
} from "../model/scales";


export function findMatchingScales(
    patternsOracle: IntervalPattern[],
    inputTones: Tone[]
): Scale[] {
    return patternsOracle.map(pattern => {
        // const pattern = p.toActiveSteps();
        const scales = Array(12).fill(0).map((_, i) => {
            const root = Tone.fromIndex(i as ToneIndex);
            const scalePattern = new ScalePattern(pattern, pattern.name);
            return new Scale(root, scalePattern);
        });
        return scales.filter(scale => {
            // Check if the input tones match the scale degrees of the scale
            return inputTones.every(tone => scale.noteIndexes.includes(tone.index));
        });
    }).flat();
}